import { render, staticRenderFns } from "./user-create.vue?vue&type=template&id=6254ca5a&scoped=true&"
import script from "./user-create.vue?vue&type=script&lang=js&"
export * from "./user-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254ca5a",
  null
  
)

export default component.exports